import apiService from './api.service'

const getValorTaxaManutencaoVigente = (oidTaxaManutencao, oidUnidade) => {
  return apiService.get(`/lottustech/taxas/valor/manutencaoVigente/${oidTaxaManutencao}/${oidUnidade}`)
}

export { getValorTaxaManutencaoVigente }
